export default {
    "/": {
        "title": "Taoify - Platform Pembuatan Situs E-commerce Independen | Produk China, Dijual Global",
        "desc": "Taoify mengintegrasikan pembuatan situs, terjemahan, penjualan, logistik, pembayaran, dan pemasaran dalam satu dashboard: 18 asisten AI membantu Anda bekerja, toko dibuka dalam 20 bahasa, produk China dijual ke seluruh dunia."
    },
    "/feature": {
        "title": "Fitur · Semua yang Anda butuhkan untuk membuka toko, ada di halaman ini · Taoify",
        "desc": "Pembuatan situs, terjemahan, penjualan, pengiriman, pembayaran, dan penarikan pelanggan – Taoify menempatkan 15 modul yang diperlukan untuk menjual produk lintas batas dalam satu dashboard, tidak perlu lagi menggunakan berbagai alat dari luar."
    },
    "/ai-staff": {
        "title": "Asisten AI · 18 asisten AI, yang paling sibuk adalah mereka yang menarik lalu lintas · Taoify",
        "desc": "Dari 18 asisten AI, 5 dari tim pertumbuhan khusus menyelesaikan masalah 'tidak ada yang datang': 12 item pemeriksaan toko, rencana pemasaran 30 hari, satu produk ditulis ulang menjadi hasil untuk 9 saluran, email pemasaran otomatis memanggil kembali pembeli sebelumnya."
    },
    "/logistics": {
        "title": "Logistik Lintas Batas · Dari tangan Anda hingga ke tangan pelanggan · Taoify",
        "desc": "Pengiriman awal, clearance, jalur utama, dan pengiriman akhir, tiga rute dipilih berdasarkan barang dan waktu. Yundto, Yanwen, dan 4PX telah terhubung, label, pelacakan, dan penanganan anomali semuanya dalam satu dashboard."
    },
    "/payment": {
        "title": "Penerimaan Pembayaran & Penyelesaian · Pelanggan dapat membayar dengan cara yang paling nyaman bagi mereka · Taoify",
        "desc": "PayPal, Stripe, kartu kredit, dan Alipay siap digunakan. Terima dalam mata uang asing, tarik dalam RMB, penyelesaian T+7, biaya dan waktu pencairan jelas."
    },
    "/pricing": {
        "title": "Harga · Paket Berlangganan + Komisi Bertingkat · Taoify",
        "desc": "Toko dikenakan biaya berdasarkan paket berlangganan: Basic $15/bulan, Standard $29/bulan, Premium $59/bulan, lebih hemat dengan pembayaran triwulanan atau tahunan. Komisi transaksi bertingkat berdasarkan volume penjualan bulanan, minimum 3%."
    },
    "/cases": {
        "title": "Kasus Penjual · Mereka Juga Melakukannya · Taoify",
        "desc": "Aksesori dari Yiwu, 3C dari Shenzhen, pakaian dari Guangzhou, dan penjual dari Jerman, AS, Prancis—enam orang, enam titik awal, satu metode yang sama."
    },
    "/sign-up": {
        "title": "Buka Toko - Daftar Gratis di Taoify",
        "desc": "Bangun toko online brand Anda dalam 10 menit, tanpa kode, coba semua fitur paket berlangganan, solusi end-to-end. Daftar sekarang di Taoify, mulai perjalanan e-commerce lintas batas Anda."
    },
    "/for-china-sellers": {
        "title": "Untuk Penjual China · Pilih Produk dan Tetapkan Harga, Sisanya Kami Tangani · Taoify",
        "desc": "Pembuatan situs, terjemahan, biaya pengiriman, pencetakan label, jawaban kepada pelanggan—platform kami menangani hal-hal rumit ini untuk Anda. Paket berlangganan + komisi bertingkat (mulai dari 3%)."
    },
    "/for-global-sellers": {
        "title": "Untuk Penjual Luar Negeri: Pilih Produk dari Rak di China, Jual di Toko Anda Sendiri · Taoify",
        "desc": "Tanpa stok, tanpa penyimpanan: pilih produk dari rantai pasokan China, dikirim langsung dari gudang China setelah pesanan masuk, Anda mendapatkan selisih harga. BuyLink juga bisa mengubah tautan 1688 dan Taobao menjadi produk Anda."
    },
    "/template-index": {
        "title": "Pasar Tema - Tema Situs Web Profesional Taoify",
        "desc": "Tema situs web profesional untuk proyek apapun, banyak template industri gratis untuk digunakan, kustomisasi merek dan fungsi sesuai kebutuhan Anda."
    },
    "/question": {
        "title": "Pusat Bantuan · Cari Jawaban di Sini Terlebih Dahulu · Taoify",
        "desc": "Pembukaan toko, dekorasi, penjualan, logistik pesanan, pembayaran, pemasaran, hak akses akun—pertanyaan umum disusun berdasarkan kategori, ajukan tiket bantuan jika tidak ditemukan."
    },
    "/about-us": {
        "title": "Tentang Taoify · Apa yang Kami Lakukan",
        "desc": "Taoify adalah platform pembuatan situs web terintegrasi untuk penjual lintas batas: pembuatan situs, terjemahan, penjualan, logistik, pembayaran, dan pemasaran dapat diselesaikan dalam satu dashboard."
    },
    "/privacy-policy": {
        "title": "Kebijakan Privasi · Taoify",
        "desc": "Bagaimana Taoify mengumpulkan, menggunakan, menyimpan, dan melindungi informasi pribadi Anda, serta hak-hak yang Anda miliki atas data Anda."
    },
    "/terms-service": {
        "title": "Syarat Layanan · Taoify",
        "desc": "Syarat dan ketentuan penggunaan layanan platform Taoify: akun, toko, pesanan, penyelesaian, dan pembagian tanggung jawab."
    },
    "/consumer-agreement": {
        "title": "Kebijakan Pengembalian Dana · Taoify",
        "desc": "Aturan pengembalian dana dan purna jual untuk pesanan di platform Taoify: syarat pengajuan, batas waktu penanganan, dan metode pembayaran."
    },
    "/user-agreement": {
        "title": "Perjanjian Pengguna · Taoify",
        "desc": "Sebelum mendaftar dan menggunakan Taoify, harap baca: Panduan Pendaftaran Akun, Pedoman Pengelolaan Toko, dan Penjelasan Layanan Platform."
    }
}
